import {pad2, pad4} from "./globals.ts";
import {parseCronExpression} from "cron-schedule";
import {TimerBasedCronScheduler} from "cron-schedule/schedulers/timer-based.js";

function element<T extends HTMLElement>(id: string, type: new () => T): T {
    const e = document.getElementById(id)
    if (e instanceof type) return e
    throw new Error(`Element ${id} is absent or mismatches type`)
}

const settingsButton = element('settingsButton', HTMLButtonElement)
const settingsDiv = element('settings', HTMLElement)
const alwaysNextCheckbox = element('alwaysNext', HTMLInputElement)
const ceilCheckbox = element('ceil', HTMLInputElement)
const gaokaoYearInput = element('gaokaoYear', HTMLInputElement)
const countdownDiv = element('countdown', HTMLElement)
const timeDiv = element('time', HTMLElement)
const dateDiv = element('date', HTMLElement)
const messageDiv = element('message', HTMLElement)

// Force using Asia/Shanghai time. We don't consider Asia/Urumqi[+06:00] or other timezones
// since Chinese Gaokao strictly rely on Asia/Shanghai timezone.
function getGaokaoDate(year: number | string) {
    return new Date(pad4(year) + '-06-07T00:00:00+08:00')
}

function nextYear() : number {
    const thisYear = new Date().getFullYear()
    let nextGaokaoYear = thisYear
    if (new Date() > getGaokaoDate(thisYear)) {
        nextGaokaoYear += 1
    }
    return nextGaokaoYear
}

function timeNow() : string {
    const now = new Date()
    return `${pad2(now.getHours())}:${pad2(now.getMinutes())}:${pad2(now.getSeconds())}`
}

const daysOfWeek = '日一二三四五六'
function dateNow(): string {
    const now = new Date()
    return `${now.getFullYear()}年${now.getMonth()+1}月${now.getDate()}日 星期${daysOfWeek[now.getDay()]}`
}

const messageGoodLuck = "高考已经开始了！祝你成功！"

function updateCountdown() {
    const now = new Date()
    const toInt = ceilCheckbox.checked ? Math.ceil : Math.floor

    let gaokaoYear: string
    const gaokaoYearStorage = localStorage.getItem('gaokaoYear');
    if (gaokaoYearStorage && !alwaysNextCheckbox.checked) {
        gaokaoYear = gaokaoYearStorage
    } else {
        gaokaoYear = '' + nextYear()
    }

    const gaokaoDate = getGaokaoDate(gaokaoYear);
    const timeLeftMillis = gaokaoDate.valueOf() - now.valueOf()
    const days = toInt(timeLeftMillis / (1000 * 60 * 60 * 24))
    countdownDiv.innerHTML= `${new Date(gaokaoDate).getFullYear()}高考倒计时<br><span class='countdown'>${days}</span> 天`
    messageDiv.textContent = timeLeftMillis <= 0 ? messageGoodLuck : ''
}

function updateTime() {
    timeDiv.textContent = timeNow()
    dateDiv.textContent = dateNow()
}

// event listeners

settingsButton.addEventListener('click', () => {
    // Toggle display
    settingsDiv.style.display = settingsDiv.style.display === 'none' ? 'block' : 'none'
});

alwaysNextCheckbox.addEventListener('change', () => {
    localStorage.setItem('alwaysNext', String(alwaysNextCheckbox.checked))
    updateCountdown()
});

gaokaoYearInput.addEventListener('change', () => {
    localStorage.setItem('gaokaoYear', gaokaoYearInput.value)
    updateCountdown()
});

ceilCheckbox.addEventListener('change', () => {
    localStorage.setItem('ceilDays', String(ceilCheckbox.checked))
    updateCountdown()
})

// Load settings from localStorage
const savedAlwaysNext = localStorage.getItem('alwaysNext');
if (savedAlwaysNext !== null) {
    alwaysNextCheckbox.checked = savedAlwaysNext === 'true';
}

const savedCeilDays = localStorage.getItem('ceilDays');
if (savedCeilDays !== null) {
    ceilCheckbox.checked = savedCeilDays === 'true';
}

let savedGaokaoYear = localStorage.getItem('gaokaoYear');
if (!savedGaokaoYear) {
    savedGaokaoYear = `${nextYear()}`;
    localStorage.setItem('gaokaoYear', savedGaokaoYear);
}
gaokaoYearInput.value = savedGaokaoYear;

// Initial update
function updateAll() {
    updateTime()
    updateCountdown()
}

updateAll()

const cronEverySecond = parseCronExpression('* * * * * *')
TimerBasedCronScheduler.setInterval(cronEverySecond, updateAll)